export const rank = {
    1: 'Member',
    2: 'Silver',
    3: 'Gold',
    4: 'Platinum',
}